// extracted by mini-css-extract-plugin
module.exports = {"videoWrapper":"YouTubeVideo-module--videoWrapper--3zd2k","poster":"YouTubeVideo-module--poster--pnomR","playButton":"YouTubeVideo-module--playButton--3VgRi"};